import { SITE_URL } from "../../config/site";
import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";
import SEO from "../../components/SEO";

import "./HelpPage.css";

export default function HelpPage() {
  return (
    <>
 <SEO
  title="Ayuda sobre pedidos personalizados | Imalandia"
  description="Resuelve dudas sobre cómo crear imanes personalizados, collages, marcos, tiempos de producción, envíos y pedidos especiales."
  canonical={`${SITE_URL}/ayuda`}
/>
      <Header />

      <main className="help-page">
        <section className="help-hero">
          <p className="help-eyebrow">Ayuda</p>

          <h1>Preguntas frecuentes</h1>

          <p>
            Aquí tienes las respuestas a las dudas más habituales sobre nuestros
            imanes personalizados, collages, marcos y accesorios.
          </p>
        </section>

        <section className="help-list">
          <article className="help-item">
            <h2>¿Cómo funciona esto?</h2>

            <p>
              Elige el producto que quieres personalizar, sube tus fotos o
              selecciona las opciones disponibles y revisa la vista previa antes
              de hacer tu pedido. Según el producto, podrás crear imanes,
              probar marcos, preparar un collage magnético o comprar accesorios
              decorativos.
            </p>
          </article>

          <article className="help-item">
            <h2>¿Cuánto dura la producción?</h2>

            <p>
              Los productos personalizados se preparan con cuidado una vez
              confirmado el pago. Como referencia, la producción suele tardar
              entre 2 y 5 días laborables, dependiendo del tipo de producto, la
              cantidad y la carga de pedidos.
            </p>
          </article>

          <article className="help-item">
            <h2>¿Cuáles son las tarifas de envío?</h2>

            <p>
              Envío sin sorpresas: los pedidos para España peninsular tienen
              una tarifa plana de 4,95 €, que se muestra en el carrito antes
              de continuar al pago.
            </p>

            <p>
              Para Baleares, Canarias, Ceuta, Melilla u otros destinos, te
              recomendamos consultarnos antes de hacer el pedido.
            </p>
          </article>

          <article className="help-item">
            <h2>¿Qué nos diferencia?</h2>

            <p>
              Cuidamos cada detalle del proceso: trabajamos con maquinaria e impresoras de primera calidad para lograr una impresión nítida, 
              con colores vivos y gran definición. Además, utilizamos papel fotográfico de calidad y materiales premium para ofrecer un acabado 
              más profesional y consistente en cada pedido. El resultado es un producto que se ve mejor de cerca, se nota en el tacto y mantiene su 
              calidad con el paso del tiempo.
            </p>
          </article>

          <article className="help-item">
            <h2>¿Cuál es nuestra política de pedidos?</h2>

            <p>
              imalandia se reserva el derecho de rechazar o cancelar cualquier pedido, a su discreción, por: contenido prohibido 
              (ofensivo/ilegal o que infrinja derechos), información incompleta (datos de envío o contacto no válidos) 
              o problemas de pago (rechazos, devoluciones de cargo o fallos de autorización).
            </p>

            <p>
              Si detectas un error justo después de comprar, escríbenos cuanto
              antes para intentar ayudarte.
            </p>
          </article>

          <article className="help-item">
            <h2>¿Hacéis pedidos al por mayor?</h2>

            <p>
              Sí. Podemos valorar pedidos para eventos, empresas, tiendas,
              celebraciones o campañas especiales. Escríbenos desde la página de
              contacto indicando el producto, la cantidad aproximada y la fecha
              en la que lo necesitas.
            </p>
          </article>
        </section>
      </main>

      <Footer />
    </>
  );
}
